export default __webpack_public_path__ + "static/media/postgresql.87519c30.png";